/* Koleksiyon / arama: sol filtre sütunu, sabit başlığın hemen altında yapışık kalır.
   Başlığın alt satırı (menü) aşağı kaydırınca gizlendiği için boşluk her kaydırmada yeniden ölçülür. */
(() => {
  const root = document.documentElement;
  const header = document.querySelector('header.shopify-section, #header-group header, #header-component');
  if (!header || !document.querySelector('.facets--vertical')) return;

  let last = -1;
  const update = () => {
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    if (bottom === last) return;
    last = bottom;
    root.style.setProperty('--axess-sticky-top', `${bottom + 16}px`);
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
